import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import { toast } from "react-toastify";
import ReCAPTCHA from "react-google-recaptcha";
// import Fab from '@mui/material/Fab';
// import WhatsAppIcon from '@mui/icons-material/WhatsApp';
// import { Auth } from 'aws-amplify';
import { FloatingWhatsApp } from "react-floating-whatsapp";
import { defaultCountries, parseCountry } from "react-international-phone";
import { useLocation } from 'react-router-dom';
import "./RSVPForm.css";

import SuccessIcon from "../../assets/svg/success_icon.svg";
import VencoLogo from "../../assets/svg/venco_logo.svg";
import VencoIcon from "../../assets/svg/venco_icon.svg";
// import Pin from "../../assets/svg/pin.svg";
import CloseIcon from "../../assets/svg/close-round.svg";
import {
  confirm_community_onboarding,
  get_countries,
  get_location,
  request_community_onboarding,
  request_otp,
  signIn,
  verify_otp,
} from "../../api/auth";
import { MapPin, X } from "phosphor-react";
import CustomPhoneInput from "../INPUTS/CustomPhoneInput";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Spinner from "../BUTTONS/Spinner";
import { create_event_rsvp, request_rsvp_otp } from "../../api/event";

export const sleep = (milliseconds) => {
  return new Promise((resolve) => setTimeout(resolve, milliseconds));
};

export default function RSVPForm(props) {
  const navigate = useNavigate();

  const [activeSection, setActiveSection] = useState("form"); // message
  // const [country_code, setCountryCode] = useState("ng");

  const [selectedCountry, setSelectedCountry] = useState(
    parseCountry(defaultCountries[138])
  );

  const presentCountry = useSelector((state) => state.geoDetails.country);
// console.log(presentCountry);

  function getQueryParam(name, search) {
    const params = new URLSearchParams(search);
    return params.get(name);
  }

  const location = useLocation();
  const referralCode = getQueryParam('ref', location.search);

  useEffect(() => {
    if (presentCountry !== "Global") {
      const name = "country";
      const name2 = "countryCom";
      setInputValues((prevState) => ({
        ...prevState,
        [name]: presentCountry,
        [name2]: presentCountry,
      }));
    }

    // if (referralCode) {
    //   const name = "comment";
    //   setInputValues((prevState) => ({
    //     ...prevState,
    //     [name]: referralCode,
    //   }));
    // }
  }, [presentCountry, ]);

  const [modalSection, setModalSection] = useState(0);
  const [inputValues, setInputValues] = useState({
    // community info
    communityName: "",
    communityID: "",
    noOfProperties: "",
    country: "",
    countryCom: "",
    communityCity:"",
    state: "",
    streetAddress: "",
    communityDomainName: "",
    isForExistingGroup: false,
    hearAboutUs: '', // This will store the selected option
    otherSource: '',  // This will store the custom input if "Others" is selected

    // personal info
    firstName: "",
    lastName: "",
    email: "",
    phoneNo: "",
    customRole: "",
    userRole: "",
    userId: "",
    stakeholder: '',

    // meters
    electricMeters: false,
    waterMeters: false,
    gasMeters: false,
    noMeters: false,

    communityGroup: null,
    otp: "",
    comment: "",
  });
  const [errMsg, setErrMsg] = useState({
    // community info
    communityName: "",
    communityID: "",
    noOfProperties: "",
    country: "",
    countryCom:"",
    citycom:"",
    state: "",
    streetAddress: "",
    communityDomainName: "",

    // personal info
    firstName: "",
    lastName: "",
    email: "",
    phoneNo: "",
    customRole: "",
    userRole: "",
    userId: "",
    stakeholder: '',

    // meters
    electricMeters: "",
    waterMeters: "",
    gasMeters: "",
    noMeters: "",

    otp: "",
    communityGroup: "",
  });
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [otpModalIsOpen, setOtpModalIsOpen] = useState(false);  
  const [tempId, setTempId] = useState("");
  // eslint-disable-next-line
  const [successMsg, setSuccessMsg] = useState(
    "Your request has be received, but Venco is currently available in United States, you’d be the first to know as soon as we launch there."
  );
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [userInfo, setUserInfo] = useState(null);
  const [isPersonalInfoEditable, setIsPersonalInfoEditable] = useState(true);
  
  const [placeSuggestions, setPlaceSuggestions] = useState([]);
  const [showplaceSuggestions, setShowplaceSuggestions] = useState(false);
  const [countries, setCountries] = useState([]);

  const [isRecaptchaVerified, setRecaptchaVerified] = useState(false);

  const [phoneErrMsg, setPhoneErrMsg] = useState("");


  const recaptchaRef = React.createRef();

  const __DEV__ = process.env.NODE_ENV === 'development';

  useEffect(() => {
    getCountries();
    // eslint-disable-next-line
  }, []);

  const handleInputChange = (event) => {
    const target = event.target;
    const value =
      target.type === "checkbox" || target.type === "radio"
        ? target.checked
        : target.value;
    const name = target.name;
    setInputValues((prevState) => ({
      ...prevState,
      [name]: value,
    }));
// console.log(inputValues);

    if (name === "isForExistingGroup" && value === true) {
      // console.log('userInfo?.community_groups?', userInfo?.community_groups[3].name);
      setModalSection(0);
      setModalIsOpen(true);
    }
  };

  const handlePhoneNumberInput = (e) => {
    const target = e.target;
    const name = target.name;
    if (target.value.length > 15) {
      setPhoneErrMsg("Phone number cannot exceed 15 digits");
      return;
    } else {
      setPhoneErrMsg("");
    }
    if (target.value.length > 1 && target.value.charAt(0) === "0") {
      // Remove the leading '0'
      setInputValues((prevState) => ({
        ...prevState,
        [name]: target.value.slice(1),
      }));
      return;
    }
    setInputValues((prevState) => ({
      ...prevState,
      [name]: target.value,
    }));
  };

  const handleStreetChange = async (event) => {
    const target = event.target;
    const value = target.value;

    setInputValues((prevState) => ({
      ...prevState,
      streetAddress: value,
    }));
    if (value.length > 3 && (value.length === 3 || value.length % 2 === 0)) {
      await getLocation(value);
    }
  };

  // eslint-disable-next-line
  const onRecaptchaChange = (value) => {
    setRecaptchaVerified(value);
  };

  const getLocation = async (query) => {
    try {
      var params = {
        use_default: false,
        input_text: query,
        language: "EN",
        country: inputValues.country,
        countryCom: inputValues.countryCom,
      };

      // console.log('getLocation params', params);

      const response = await get_location(params);

      if (response.ok) {
        const res = await response.json();

        // console.log("res", res);
        if (Boolean(res)) {
          setPlaceSuggestions(res);
          setShowplaceSuggestions(true);
        }
      } else {
        setPlaceSuggestions([]);
        setShowplaceSuggestions(false);
      }
    } catch (error) {
      setPlaceSuggestions([]);
      setShowplaceSuggestions(false);
    }
  };

  function isValidEmail(value) {
    // Use a regular expression to validate the email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(value);
  }

  function isValidPhoneNumber(value) {
    // Use a regular expression to validate the phone number format
    const phoneRegex = /^\d{10}$/;
    return phoneRegex.test(value);
  }

  function sortByActiveStatus(a, b) {
    if (a.active === b.active) {
      // If both items have the same active status, maintain the original order
      return 0;
    } else if (a.active === 1) {
      // Move items with active: 1 to the top
      return -1;
    } else {
      // Move items with active: 0 to the bottom
      return 1;
    }
  }

  const getCountries = async () => {
    try {
      await sleep(2000);
      const res = await get_countries();
      // console.log("res status", res.status)
      if (res.ok) {
        const { message } = await res.json();
        const data = message.data;
        data.sort(sortByActiveStatus);
        setCountries(data);
      } else {
        setCountries([
          {
            country_name: "Ghana",
            country_code: "gh",
            currency: "GHS",
            active: 1,
            emergency_numbers: [
              {
                emergency_number_type: "Police",
                emergency_number: "191",
              },
              {
                emergency_number_type: "Fire",
                emergency_number: "192",
              },
              {
                emergency_number_type: "Medical",
                emergency_number: "193",
              },
            ],
          },
          {
            country_name: "Kenya",
            country_code: "ke",
            currency: "KES",
            active: 1,
            emergency_numbers: [
              {
                emergency_number_type: "General",
                emergency_number: "112",
              },
            ],
          },
          {
            country_name: "Nigeria",
            country_code: "ng",
            currency: "NGN",
            active: 1,
            emergency_numbers: [
              {
                emergency_number_type: "General",
                emergency_number: "112",
              },
            ],
          },
        ]);
      }
    } catch (error) { }
  };

  const requestRSVPOTP = async (event) => {
    event.preventDefault(); // Prevent page refresh

    const country = selectedCountry;
    const phoneNumber = "+" + country.dialCode + parseInt(inputValues.phoneNo);

    try {
      if (!__DEV__) {
        if (!isRecaptchaVerified) {
          toast.error("Error submitting, please verify reCAPTCHA and try again", {
            position: "top-center",
            autoClose: 15000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          return false;
        }
      }
      
      setIsSubmitting(true);

      console.log("props.eventID", props.eventID);
      
      var params = {
        event_id: props.event?.event_id,
        is_guest: 1,
        phone_number: phoneNumber,
      };

      if (Boolean(inputValues.email.length)) {
        params['email'] = inputValues.email
      }
      

      console.log('params', params);


      var response = await request_rsvp_otp(params);
      var res = await response.json();

      // console.log('response status', response.status);
      console.log('res', res);

      setIsSubmitting(false);
      if (response.ok) {
        setTempId(res.auth_id);
        // console.log("res.tmp_id", res.tmp_id);
        setInputValues((prevState) => ({
          ...prevState,
          otp: "",
        }));
        setErrMsg((prevState) => ({
          ...prevState,
          otp: "",
        }));
        setOtpModalIsOpen(true);

        // return {
        //   status: 'success'
        // }
      } else {
        if (response.status === 500) {
          toast.error(res.message || "Internal server error", {
            position: "top-center",
            autoClose: 15000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            zIndex: 1000,
          });
        } else {
          toast.error(res.message || "Something went wrong", {
            position: "top-center",
            autoClose: 15000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            zIndex: 1000,
          });
        }
        setIsSubmitting(false);
      }
    } catch (error) {
      setIsSubmitting(false);
      toast.error("Something went wrong. Error: " + error.message, {
        position: "top-center",
        autoClose: 15000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        zIndex: 1000,
      });
      setIsSubmitting(false);
    }
    return false;
  };

  const createRSVP = async () => {
    setIsSubmitting(true);
    const country = selectedCountry;
    const phoneNumber = "+" + country.dialCode + parseInt(inputValues.phoneNo);
    try {
      var params = {
        tmp_id: tempId,
        otp: inputValues.otp,
        guest_name: inputValues.firstName + ' ' + inputValues.lastName,
        first_name: inputValues.firstName,
        last_name: inputValues.lastName,
        email: inputValues.email,
        phone_number: phoneNumber,
        comment: inputValues.comment,
        event_id: props.event?.event_id,
        // test: 1
      };

      if (props.isRema) {
        params['stakeholder'] = inputValues.stakeholder
      }

      if (Boolean(referralCode)) {
        params['referral_code'] = referralCode
      }

      // console.log(' confirm_community_onboarding params', params);

      const res = await create_event_rsvp(params);
      const response = await res.json();

      // console.log('res status', res.status)
      console.log('response', response)
      setIsSubmitting(false);
      if (res.ok) {
        setSuccessMsg(response?.message || "Success");
        closeVerifyUserModal();
        setActiveSection("message");
      } else {
        toast.error(response.message, {
          position: "top-right",
          autoClose: 15000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        setIsSubmitting(false);
      }
    } catch (error) {
      toast.error("Something went wrong. Error: " + error.message, {
        position: "top-center",
        autoClose: 15000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      setIsSubmitting(false);
    }
  };

  const closeVerifyUserModal = () => {
    setIsSubmitting(false);
    setOtpModalIsOpen(false);
  };

  const customStyles = {
    content: {
      // top: '50%',
      // left: '50%',
      // right: 'auto',
      // bottom: 'auto',
      // marginRight: '-50%',
      zIndex: 999999,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.2)",
      backdropFilter: "blur(2px)",
    },
  };

  const roles = [
    "Developer",
    "Estate Admin",
    "Facility Manager",
    "Resident",
    "Vendors"
  ]

  return (
    <div className=" bg-grey-50 rounded-lg px-4 py-10 lg:px-10 lg:py-16 xl:px-[80px] xl:py-[51px] w-full md:w-3/5 lg:w-auto">
      <div className="">
        {activeSection === "form" && (
          <>
            <div className="">
              {/* <a href="/">
                <img
                  src={VencoLogo}
                  alt="venco logo"
                  className="mx-auto w-[150px] md:w-[200px] lg:w-[400px] "
                />
              </a> */}
              <div>
                <p className="font-sora font-semibold text-[24px] md:text-2xl lg:text-[40px] text-center xl:max-w-[927px] xl:mx-auto md:text-left">
                  You're Invited
                </p>
                <div className="h-6"></div>
                <p className="text-sm font-medium text-center md:text-left">
                  Confirm that you would be attending, to get your access pass.
                </p>

              </div>
            </div>

            <form
              // className="rounded-t-xl md:rounded-xl md:max-w-[500px] lg:max-w-[798px] mx-auto px-5 py-10 mt-[60px] xl:p-20 flex flex-col gap-4 md:gap-8"
              className="pt-10 flex flex-col gap-4 md:gap-5 xl:min-h-[600px]"
              onSubmit={requestRSVPOTP}
            >

              <div className="flex flex-col md:flex-row gap-4">
                <div className="flex-1">
                  <input
                    type="text"
                    value={inputValues.firstName}
                    name="firstName"
                    placeholder="First Name"
                    onChange={handleInputChange}
                    autoComplete="name"
                    required
                    disabled={!isPersonalInfoEditable}
                    // className={this.props.is_erred ? "outline-input-field-erred" : (this.state.is_focus ? "outline-input-field-active" : "outline-input-field")}
                    className="formInput"
                  />
                </div>
                <div className="flex-1">
                  <input
                    type="text"
                    value={inputValues.lastName}
                    name="lastName"
                    id="lastName"
                    placeholder="Last Name"
                    onChange={handleInputChange}
                    autoComplete="name"
                    required
                    disabled={!isPersonalInfoEditable}
                    // className={this.props.is_erred ? "outline-input-field-erred" : (this.state.is_focus ? "outline-input-field-active" : "outline-input-field")}
                    className="formInput"
                  />
                </div>
              </div>

              <div className="">
                <input
                  type="text"
                  value={inputValues.email}
                  name="email"
                  id="email"
                  placeholder="Email Address"
                  onChange={handleInputChange}
                  autoComplete="email"
                  required
                  disabled={!isPersonalInfoEditable}
                  // className={this.props.is_erred ? "outline-input-field-erred" : (this.state.is_focus ? "outline-input-field-active" : "outline-input-field")}
                  className="formInput"
                />
              </div>

              <div>
                <div
                  className={`flex font-inter items-center relative  gap-2.5`}
                >
                  <CustomPhoneInput
                    selectedCountry={selectedCountry}
                    setSelectedCountry={setSelectedCountry}
                  />

                  <input
                    type='tel'
                    value={inputValues.phoneNo}
                    name="phoneNo"
                    placeholder="Phone Number"
                    onChange={handlePhoneNumberInput}
                    autoComplete="tel"
                    required
                    disabled={!isPersonalInfoEditable}
                    // className={this.props.is_erred ? "outline-input-field-erred" : (this.state.is_focus ? "outline-input-field-active" : "outline-input-field")}
                    className="formInput"
                  />
                </div>
                <p
                  className="text-red-500 text-xs mt-1 ml-1 min-h-[18px]"
                >
                  {phoneErrMsg}
                </p>
              </div>

              {/* <div className="">
                <input
                  type="text"
                  value={inputValues.comment}
                  name="comment"
                  id="comment"
                  placeholder="Additional Comments"
                  onChange={handleInputChange}
                  autoComplete="comment"
                  disabled={!isPersonalInfoEditable}
                  className="formInput"
                />
              </div> */}

              {
                props.isRema && (
                  <div className="">
                    <select 
                      name="stakeholder" 
                      id="stakeholder"
                      // className="input-field"
                      className="formInput"
                      value={inputValues.stakeholder}
                      onChange={handleInputChange}
                      required
                    >
                      <option value="" defaultValue disabled>Community Stakeholder</option>
                      {
                        roles.map((item, index) => {
                          return (  
                            <option key={index} value={item}>{item}</option>
                          )
                        })
                      }
                      
                    </select>
                  </div> 
                )
              }
              

              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginTop: 25,
                }}
              >
                <ReCAPTCHA
                  ref={recaptchaRef}
                  tabindex={1}
                  sitekey={"6LcstiIoAAAAAAdRrvboVRDpAcjT5DXizvjxqAth"}
                  onChange={onRecaptchaChange}
                />
              </span>
              <button
                disabled={isSubmitting}
                className="w-full font-sora lg:text-lg font-semibold text-green-500 text-sm md:text-base  bg-light-green-500 py-4 rounded-lg disabled:cursor-not-allowed items-center justify-center justify-items-center content-center"
                type="submit"
              >
                {isSubmitting ? <Spinner color="text-green-500" /> : "I Confirm"}
                {/* <img 
                      src={RightArrow} 
                      alt="Right arrow" 
                    /> */}
              </button>

              <p className="text-center leading-[18px] text-xs lg:text-sm">
                By clicking the <span className="font-semibold">“Submit”</span>
                button, you agree to Venco's{" "}
                <span
                  className="text-light-purple-700  underline underline-offset-4 leading-[18px] cursor-pointer"
                  onClick={() => {
                    navigate("/terms-and-condition");
                  }}
                >
                  {" "}
                  terms of service{" "}
                </span>
                and{" "}
                <span
                  className="text-slate-500  underline underline-offset-4 leading-[18px] cursor-pointer"
                  onClick={() => {
                    navigate("/privacy-policy");
                  }}
                >
                  privacy policy{" "}
                </span>
              </p>
            </form>
          </>
        )}
        {activeSection === "message" && (
          <>
            <div
              className="
            p-4 space-y-4"
            >
              <div className="p-4 content-center items-center justify-center justify-items-center">
              {/* <img
                src={SuccessIcon}
                className="w-[120px] self-center"
                alt="venco-logo"
              /> */}
                {/* <a href="/">
                  <img
                    src={VencoLogo}
                    alt="venco logo"
                    className="mx-auto w-[150px] md:w-[200px] lg:w-[400px] "
                  />
                </a> */}
                <div>
                  <p className="font-sora text-new-black-500 text-[32px] xl:text-[36px] font-semibold leading-[42px] text-center">
                    RSVP Sent!
                  </p>
                </div>
              </div>
              <div className="bg-white rounded-xl md:max-w-[500px] lg:max-w-[650px] mx-auto px-5 py-5 mt-[20px] xl:p-20 flex flex-col gap-4 md:gap-8">
                <div className="font-inter text-sm text-left  space-y-4 md:text-base xl:text-lg leading-[150%]">
                  <p>
                    Your RSVP has been sent for final approval, after which you would be sent your access code via Email and SMS.
                  </p>
                </div>
              </div>
            </div>
          </>
        )}
        {/* {activeSection === "message" && (
          <>
            <div className="header">
              <a href="https://venco.africa/">
                <img src={VencoLogo} className="logo" alt="venco-logo" />
              </a>
            </div>
            <div className="section-1">
              <img
                src={SuccessIcon}
                className="success-icon"
                alt="venco-logo"
              />
              <p>{successMsg}</p>
              <a href="https://venco.africa/">Back To Home</a>
            </div>
          </>
        )} */}

        <FloatingWhatsApp
          phoneNumber="2349131055071"
          accountName="Venco Support"
          statusMessage="Online"
          avatar={VencoIcon}
        />
      </div>

      <Modal
        isOpen={otpModalIsOpen}
        onRequestClose={() => closeVerifyUserModal()}
        style={customStyles}
        // contentLabel="Vessel Modal"
        // overlayClassName="modal-overlay"
        className="vessel-modal"
      >
        <div className="mt-[250px] bg-white rounded-xl p-5 m-4 max-w-[460px] lg:p-[30px]">
          <div className="flex justify-end pb-2">
            <div className="" onClick={() => closeVerifyUserModal()}>
              <X weight="bold" className="text-base font-semibold" />
            </div>
          </div>
          <p className="modalTitle">Please verify OTP</p>
          <p className="modalSubtitle">
            Please enter the OTP code that was sent to your phone
            number
          </p>
          <p className="modalSubtitle text-orange-500 italic">
            NB: No OTP code would be sent if you have already RSVPed for this event previously.
          </p>

          <input
            type="number"
            value={inputValues.otp}
            name="otp"
            placeholder=" Type your OTP code"
            onChange={handleInputChange}
            autoComplete="text"
            required
            // className={this.props.is_erred ? "outline-input-field-erred" : (this.state.is_focus ? "outline-input-field-active" : "outline-input-field")}
            // className="input-field"
            className={`formInput mt-5 ${Boolean(errMsg.userId.length) ? "border-red-500" : ""
              }`}
          />

          {Boolean(errMsg.otp.length) ? (
            <p className="input-field-err-msg">{errMsg.otp}</p>
          ) : null}

          <button
            className="primaryButton w-full mt-[30px]"
            onClick={createRSVP}
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Submitting...' : 'Submit'}
          </button>
        </div>
      </Modal>
    </div>
  );
}
